const texts = {
  title: 'Aprovação automática +MAISACESSO',
  firstParagraph: `Sua Instituição de Ensino está qualificada para usar a\n aprovação
  automatizada no convênio com +MAISACESSO.`,
  secondParagraph: `Com a aprovação automática, você pode definir regras na\n
  concessão do crédito, que aprovarão automaticamente\n estudantes
  que atenderem aos critérios.`,
  thirdParagraph:
    'Você não possui uma automação criada.\n Que tal criarmos uma?',
  buttonText: 'Criar aprovação automática',
};

export default texts;
